<template>
    <div class="page box">
        <div v-if="loading" class="loading">
            Loading...
        </div>
        <div v-if="error" class="notification is-light">
            <b>{{ error | capitalize }}</b>
            <figure class="media-left">
                <p class="image is-256x256">
                    <img alt="AEMP 404" width="256" src="../assets/notfound.svg">
                </p>
            </figure>
        </div>
        <div v-if="page" class="content">
            <h3 class="title is-4">{{page.title | capitalize}}</h3>
            <span v-html=" page.content"></span>
        </div>
    </div>
</template>
<script>
const axios = require('axios');
export default {
    data: function() {
        return {
            loading: true,
            page: null,
            error: null
        }
    },
    name: 'Page',
    props: {
        msg: String
    },
    created() {
        this.fetchData()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            this.error = this.page = null
            this.loading = true
            var vm = this
            //var fetchurl = this.$api_url_pages
            var fetchurl = this.$api_url_pages+'&limit=1&populate=1&filter[slug]='+encodeURIComponent('page/' + vm.$route.params.id)

            axios({
                    method: 'get',
                    url: fetchurl
                    /*
                    method: 'post',
                    url: fetchurl,
                    headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        filter: { slug: 'page/' + vm.$route.params.id },
                        //fields: {fieldA:1},
                        limit: 1,
                        sort: { _created: -1 },
                        populate: 1, // resolve linked collection items
                        lang: 'fr' // return normalized language fields (fieldA_de => fieldA)
                    })*/
                }).then(function(response) {
                    vm.loading = false
                    if (response.data.entries.length > 0) {
                        vm.page = response.data.entries[0]
                        vm.error = null
                    } else {
                        vm.page = null
                        vm.error = 'page introuvable'
                    }
                })
                .catch(function() {
                    //console.log("Erreur ! Impossible d'accéder à l'API." + error)
                    vm.error = 'page introuvable'
                })

        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
    min-height: 300px;
    margin-bottom: 40px;
}
</style>